// US Federal Holidays — computed, no external dependency.
// Used by the WO range picker (§1.3) and Calendar views (§4.6).

function nthWeekdayOfMonth(year, month, weekday, n) {
  // month: 0-11, weekday: 0(Sun)-6(Sat), n: 1-based occurrence
  const first = new Date(year, month, 1);
  const offset = (weekday - first.getDay() + 7) % 7;
  return new Date(year, month, 1 + offset + (n - 1) * 7);
}

function lastWeekdayOfMonth(year, month, weekday) {
  const last = new Date(year, month + 1, 0);
  const offset = (last.getDay() - weekday + 7) % 7;
  return new Date(year, month, last.getDate() - offset);
}

function observed(date) {
  // Federal observance: Sat -> preceding Fri, Sun -> following Mon
  const d = new Date(date);
  if (d.getDay() === 6) d.setDate(d.getDate() - 1);
  else if (d.getDay() === 0) d.setDate(d.getDate() + 1);
  return d;
}

function iso(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/**
 * Returns a Map of ISO date string -> holiday name for the given year.
 * Both the actual date and the federally observed date are included.
 */
export function getFederalHolidays(year) {
  const fixed = [
    [new Date(year, 0, 1), "New Year's Day"],
    [new Date(year, 5, 19), 'Juneteenth'],
    [new Date(year, 6, 4), 'Independence Day'],
    [new Date(year, 10, 11), 'Veterans Day'],
    [new Date(year, 11, 25), 'Christmas Day'],
  ];
  const floating = [
    [nthWeekdayOfMonth(year, 0, 1, 3), 'Martin Luther King Jr. Day'],
    [nthWeekdayOfMonth(year, 1, 1, 3), "Washington's Birthday"],
    [lastWeekdayOfMonth(year, 4, 1), 'Memorial Day'],
    [nthWeekdayOfMonth(year, 8, 1, 1), 'Labor Day'],
    [nthWeekdayOfMonth(year, 9, 1, 2), 'Columbus Day'],
    [nthWeekdayOfMonth(year, 10, 4, 4), 'Thanksgiving Day'],
  ];
  const map = new Map();
  [...fixed, ...floating].forEach(([date, name]) => {
    map.set(iso(date), name);
    map.set(iso(observed(date)), name);
  });
  return map;
}

const _cache = {};
function holidaysFor(year) {
  if (!_cache[year]) _cache[year] = getFederalHolidays(year);
  return _cache[year];
}

/** Returns the holiday name for a given Date or ISO string, or null. */
export function holidayName(dateOrIso) {
  const isoStr = typeof dateOrIso === 'string' ? dateOrIso.slice(0, 10) : iso(dateOrIso);
  const year = Number(isoStr.slice(0, 4));
  return holidaysFor(year).get(isoStr) || null;
}

export function isFederalHoliday(dateOrIso) {
  return holidayName(dateOrIso) !== null;
}
